import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-9 w-full rounded-md border border-[#D2D2D7] bg-transparent text-[#1D1D1F] hover:border-[#A1A1A6] focus-visible:outline-none focus-visible:border-[#0071E3] focus-visible:ring-[3px] focus-visible:ring-[rgba(0,113,227,0.15)] aria-[invalid=true]:border-[#FF3B30] placeholder:text-[#A1A1A6] placeholder:font-normal px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
